import { queryMarkerNamesUsed } from '../queryParameters/queryMarkers';

/**
 * The parameters a report run can supply values for.
 *
 * A fixed set, and the same one for every saved query, which is a stand-in for parameters declared
 * per query and stored alongside its SQL. Until that exists this list is what "a legal parameter"
 * means, so it is also what a query is checked against — see assertReportQueryParametersValid in
 * shared-node.
 */
export const REPORT_QUERY_PARAMETER_NAMES = ['report_from_date', 'report_to_date', 'report_as_of_date'] as const;

export type ReportQueryParameterName = (typeof REPORT_QUERY_PARAMETER_NAMES)[number];

/** The two that delimit a reporting period, as against the run's own date. */
export const REPORT_WINDOW_PARAMETER_NAMES: readonly ReportQueryParameterName[] = [
  'report_from_date',
  'report_to_date',
];

export const isReportQueryParameterName = (name: string): name is ReportQueryParameterName =>
  (REPORT_QUERY_PARAMETER_NAMES as readonly string[]).includes(name);

/** Deduped report parameters the SQL uses, in the order this set declares them. */
export const reportQueryParametersUsed = (sql: string): ReportQueryParameterName[] => {
  const used = new Set(queryMarkerNamesUsed(sql));
  return REPORT_QUERY_PARAMETER_NAMES.filter((name) => used.has(name));
};
